import * as React from 'react';
import { Label, Separator } from "@fluentui/react"
import PractitionerProtocolActivityComponent from "../PractitionerProtocolActivity/PractitionerProtocolActivity.Component"
import PractitionerProtocolVisitList from "../PractitionerProtocolVisitList/PracittionerProtocolVisit.List.Component"
import { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './PractitionerActivityFeed.Styles.css';
import ProtocolSelectorComponent from '../../../commons/component/Inputs/ProtocolSelector/ProtocolSelectorComponent';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import DateRangeSelectorComponent from '../../../commons/component/Inputs/DateRangeSelector/DateRangeSelector.Component';
import { AppState } from '../../../redux/reducers';
import { actionCreators } from '../../../redux/middleware/MedicalProtocolMiddleware';
import { Button } from '@fluentui/react-components';
import { DocumentPdf24Regular, Table24Regular } from '@fluentui/react-icons';


export const PractitionerActivityFeedComponent = (props: { practitioner: string }) => {

    const FromDate = new Date(new Date().setMonth(new Date().getMonth() - 3));

    const [DateFrom, setDateFrom] = useState<Date>(FromDate);
    const [DateTo, setDateTo] = useState<Date>(new Date());
    const [Protocols, setProtocols] = useState<number[]>([]);

    // Refs to track when user actually clicked export buttons
    const pdfExportRequested = useRef(false);
    const excelExportRequested = useRef(false);

    // Redux hooks
    const dispatch = useDispatch();
    const medicalProtocolsState = useSelector((state: AppState) => state.MedicalProtocols);

    // Get export states
    const {
        isExportingPdf,
        ExportingPdfSuccess,
        pdfBlob,
        isExportingVisitToExcel: isExportingExcel,
        ExportingVisitToExcelSuccess: ExportingExcelSuccess,
        visitExcelBlob: excelBlob
    } = medicalProtocolsState || {};

    // Helper function to download blob files
    const downloadBlob = (blob: Blob, filename: string) => {
        const url = globalThis.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        globalThis.URL.revokeObjectURL(url);
    };

    // Export handlers
    const handleExportPdf = () => {
        pdfExportRequested.current = true;
        dispatch(actionCreators.GetPractitionerVisitsPdf(props.practitioner, DateFrom, DateTo));
    };

    const handleExportExcel = () => {
        excelExportRequested.current = true;
        dispatch(actionCreators.GetPractitionerVisitsExcel(props.practitioner, DateFrom, DateTo));
    };

    // Auto-download when blobs are received and export was actually requested
    React.useEffect(() => {
        if (ExportingPdfSuccess && pdfBlob && pdfExportRequested.current) {
            const filename = `practitioner-visits-${props.practitioner}-${DateFrom.toISOString().split('T')[0]}-to-${DateTo.toISOString().split('T')[0]}.pdf`;
            downloadBlob(pdfBlob, filename);
            pdfExportRequested.current = false; // Reset the flag
        }
    }, [ExportingPdfSuccess, pdfBlob, DateFrom, DateTo, props.practitioner]);

    React.useEffect(() => {
        if (ExportingExcelSuccess && excelBlob && excelExportRequested.current) {
            const filename = `practitioner-visits-${props.practitioner}-${DateFrom.toISOString().split('T')[0]}-to-${DateTo.toISOString().split('T')[0]}.xlsx`;
            downloadBlob(excelBlob, filename);
            excelExportRequested.current = false; // Reset the flag
        }
    }, [ExportingExcelSuccess, excelBlob, DateFrom, DateTo, props.practitioner]);

    const changeDateFrom = (newDateFrom: Date) => {
        setDateFrom(newDateFrom);
    }

    const changeDateTo = (newDateTo: Date) => {
        setDateTo(newDateTo);
    }

    const controls = (
        <div className='ActivityControls'>
            <div>
                <Label htmlFor={'ActivityFeedSlider'}>
                    Rango de actividad
                </Label>

                <DateRangeSelectorComponent
                    onDateChange={(dateFrom: Date | undefined, dateTo: Date | undefined) => { dateFrom && changeDateFrom(dateFrom); dateTo && changeDateTo(dateTo) }}
                    startDateLabel={''}
                    startDate={DateFrom}
                    endDateLabel={''}
                    endDate={DateTo}
                    className={'DateRangeContainer'} />
            </div>
            <Separator vertical />
            <div>
                <Label>Protocolos</Label>
                <ProtocolSelectorComponent selectionLimit={undefined} onChangeSelection={(protocolsSelected: Protocol[] | undefined) => setProtocols(protocolsSelected?.map((protocol: Protocol) => { return protocol.id }) || [])} />
            </div>
            <div>
                <div>
                    <Button
                        icon={<DocumentPdf24Regular />}
                        style={{ marginRight: 8 }}
                        disabled={isExportingPdf}
                        onClick={handleExportPdf}
                    >{isExportingPdf ? "Exportando PDF..." : "Exportar PDF"}
                    </Button>
                    <Button
                        icon={<Table24Regular />}
                        disabled={isExportingExcel}
                        onClick={handleExportExcel}
                    >{isExportingExcel ? "Exportando Excel..." : "Exportar Excel"}
                    </Button>
                </div>
            </div>
        </div>
    );

    return (
        <>
            {controls}
            <Separator />
            <div className='CalendarContainer'>
                <PractitionerProtocolActivityComponent PractitionerId={props.practitioner} DateFrom={DateFrom} DateTo={DateTo} protocolsIds={Protocols} />
            </div>
            <Separator />
            <PractitionerProtocolVisitList PractitionerId={props.practitioner} DateFrom={DateFrom} DateTo={DateTo} protocolsIds={Protocols} />
        </>
    )
}